import { Grid, Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import AudioBtn from '../audio/AudioBtn';

// -------------------- message component -------------------
const useStyles = makeStyles((theme) => ({
  user_message: {
    justifyContent: 'flex-end',
    display: 'flex',
  },
  message: {
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
  },
}));

function Message({ sent, data, audio_url, audio_playing, setAudioPlaying }) {
  const css = useStyles()
  if (sent) {
    // from user
    return <Grid container justify="flex-end">
      <Grid item xs={2} />
      <Grid item xs={10}>
        <Box className={`${css.user_message} ${css.message}`}>
          <Typography>
            <strong >{data}</strong>
          </Typography>
        </Box>
      </Grid>
    </Grid>
  }
  // from bot 
  return <Grid container>
    <Grid item xs={10}>
      <Box className={`${css.message}`}>
        <em>{data}</em>
        {audio_url ?
          (<>
            <br />
            <AudioBtn
              url={audio_url}
              audio_playing={audio_playing}
              setAudioPlaying={setAudioPlaying}
            />
          </>)
          : <></>}
      </Box>
    </Grid>
    <Grid item xs={2} />
  </Grid>
}

export default function Messages({ data, audio_playing, setAudioPlaying }) {
  if (data) {
    const arr = data.map((x, i) => (
      <Message
        key={i}
        sent={x.sent}
        data={x.message}
        audio_url={x.audio}
        audio_playing={audio_playing}
        setAudioPlaying={setAudioPlaying}
      />
    ))
    return arr
  }
  return <></>
}
